import { useDispatch, useSelector } from "react-redux"
import { key_local_storage_cart, urlapi } from "../../../lib/backend/data"
import { useCallback, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { calculateTotalCart } from "../../../lib/helpers/main"
import { changeValueForFreeShipping } from "../../../redux/actions/shipping_free"
import { formatoMoneda } from "../../../lib/helpers/helpers"
import { useLocation } from "react-router-dom"
import { debounce } from "@mui/material"

const FreeShippingCalculator = (props) => {
    const [ error, setError ] = useState(null)
    const [ loadingMaster, setLoadingMaster ] = useState(false)
    const [ direccion, setDireccion ] = useState(null)
    const carrito = useSelector(state => state.cart)
    const totalCart = calculateTotalCart(carrito)
    const user = useSelector(state => state.user)
    const location = useLocation()
    const dispatch = useDispatch()
    const direcciones = useSelector(state => state.direcciones)
    const value_for_free_shipping = useSelector(state => state.value_for_free_shipping)
    const [ discount, setDiscount ] = useState(value_for_free_shipping || 0)
    const [ freeShipping, setFreeShipping ] = useState(false)
    const style_bar = { background: "#af8261", color: "white" }

    const checkForFreeShipping = (data, subtotal) => {
        if(Object.keys(data).length < 1) return false
        const freeShipping = Object.keys(data).map(code_courrier => {
            if(data?.[code_courrier]?.free_shipping > 0){
                return data?.[code_courrier]?.free_shipping
            }
            return 0
        }).filter(ammount => ammount)
        const min = Math.min(...freeShipping)
        if(min > 0 && subtotal >= min) {
            setFreeShipping(true)
        } else {
            setFreeShipping(false)
        }

    }
    const validateData = (data, subtotal) => {
        checkForFreeShipping(data, subtotal)
        if(Object.keys(data).length < 1) return false
        const freeShipping = Object.keys(data).map(code_courrier => {
            if(data?.[code_courrier]?.ammount_for_free_shipping > 0){
                return data?.[code_courrier]?.ammount_for_free_shipping
            }
            return 0
        }).filter(ammount => ammount)
        if(freeShipping.length < 1) {
            setDiscount(0)
            return dispatch(changeValueForFreeShipping(0))
        }
        const value = freeShipping[0]
        dispatch(changeValueForFreeShipping(value))
        setDiscount(value)
        setFreeShipping(false)
    }
    const obtenerDatosOrden = async (latitude, longitude, subtotal) => {
        setError("")
        setLoadingMaster(true)
        return fetch(`${urlapi}/pricing/ecommerce/cobertura`,{
            method:'POST',
            body: JSON.stringify({ lat: latitude, lng: longitude, total_cart: subtotal }),
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => res.json())
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
                setError(res.errorMessage)
            } else if(res.message){
                setError(res.message)
            } else if(res.additional_data){
                validateData(res.additional_data, subtotal )
            }
            return setLoadingMaster(false)
        })
        .catch(error => {
            return setLoadingMaster(false)
        })
    }

    const fetchData = useCallback(debounce((lat, lng, total) => obtenerDatosOrden(lat, lng, total)), 1000, [])

    const verifyAddressServiceRatio = (new_total) => {
        if(user?.billing?.address_1){
                const i = direcciones.findIndex(dire => dire?.formated_address === user?.billing?.address_1)
                if(i > -1) {
                    const address = direcciones[i]
                    if(address){
                        setDireccion(address)
                        if(typeof address?.geo_data?.lat !== "undefined" && typeof address?.geo_data?.lng !== "undefined") fetchData(address?.geo_data?.lat, address?.geo_data?.lng, new_total)
                    }

                }
            }
    }

    useEffect(() => {
        const new_total = calculateTotalCart(carrito)
        verifyAddressServiceRatio(new_total)
    },[ totalCart ])

    
    const mostrarCampos = () => {
        
        if(!discount) return false
        const maximun = 25
        const address = direccion?.formated_address.substring(0, maximun)
        const duts = direccion?.formated_address.length > maximun ? "..." : ""
        return <div className="w-100">
            <p className="mb-0">Agrega <b style={{ fontWeight: "bold" }}>CLP {formatoMoneda(discount)}</b> para obtener envío gratis a <b style={{ fontWeight: "bold" }}>{address}{duts}</b></p>
        </div>
    }

            const maximun = 25
        const address = direccion?.formated_address.substring(0, maximun)
        const duts = direccion?.formated_address.length > maximun ? "..." : ""


    if(freeShipping === true) return <div className="p-2 text-center w-100" style={style_bar}>
            <p className="mb-0">¡Felicidades! tienes envío gratis a <b style={{ fontWeight: "bold" }}>{address}{duts}</b></p>
    </div>


    if(location.pathname === "checkout" || !discount) return false

    return <div className="p-2 text-center" style={style_bar}>
        {mostrarCampos()}
    </div>
}

export default FreeShippingCalculator